import type { ContentImportItemDto } from "./types";
import { assignOptionCodes } from "./assignOptionCodes";

export function normalizeQuestionImportItem(
  item: ContentImportItemDto
): ContentImportItemDto {
  const next = { ...item } as Record<string, unknown>;

  const options = next.options;
  if (Array.isArray(options)) {
    const prepared = options.map((raw) => {
      if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
        return { isCorrect: false } as Record<string, unknown>;
      }
      const option = { ...(raw as Record<string, unknown>) };
      if (option.isCorrect === undefined) {
        option.isCorrect = false;
      }
      return option;
    });
    next.options = assignOptionCodes(prepared);
  }

  return next as ContentImportItemDto;
}
